import { ATX_BREAKPOINT_WIDTH } from './breakpoints';

export type AtxDeviceType = 'desktop' | 'tablet' | 'mobile';

export function atxDeviceType(
  win: Pick<Window, 'innerWidth'> = window,
): AtxDeviceType {
  if (win.innerWidth <= ATX_BREAKPOINT_WIDTH.MD) {
    return 'mobile';
  }

  if (win.innerWidth <= ATX_BREAKPOINT_WIDTH.XL) {
    return 'tablet';
  }

  return 'desktop';
}
